import { InvalidFieldError } from '../../validation/errors/invalid-field-error'
import { type FieldValidation } from '../../validation/protocols/field-validation'
import { type ValidateBirthdayAdapter } from '../../validation/protocols/validate-birthday-adapter'

export class BirthdayValidation implements FieldValidation {
  private readonly validateBirthdayAdapter: ValidateBirthdayAdapter
  readonly field: string

  constructor (field: string, validateBirthdayAdapter: ValidateBirthdayAdapter) {
    this.field = field
    this.validateBirthdayAdapter = validateBirthdayAdapter
  }

  validate (value: string): Error | null {
    const isValid = this.validateBirthdayAdapter.validate(value)
    return isValid ? null : new InvalidFieldError('nascimento')
  }
}
